<template>
  <div class="container-fluid">
    <Breadcrumbs title="Búsqueda Excel" main="Configuración" />
    
    <div class="row g-4">
      <div class="col-lg-6">
        <LimiteExcelCard tipo="banco" titulo="Buscar productos por Excel" icono="image" :cargando="cargando">
          Define el limite de productos para la busqueda de prodcutos en excel en el Banco de Imágenes.
        </LimiteExcelCard>
      </div>
      <div class="col-lg-6">
        <LimiteExcelCard tipo="gs1" titulo="Buscar productos con GS1 por Excel" icono="search" :cargando="cargando">
          Define el limite de prodcutos para la busqueda de prodcutos en excel con GS1.
        </LimiteExcelCard>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import LimiteExcelCard from "@/components/LimiteExcelCard.vue";

export default {
  name: "ConfiguracionBusquedaExcel",
  components: { LimiteExcelCard },
  data() {
    return {
      cargando: false,
    };
  },
  mounted() {
    this.cargar();
  },
  methods: {
    ...mapActions("configuracion", ["consultarBusquedaExcel"]),
    async cargar() {
      this.cargando = true;
      try {
        await this.consultarBusquedaExcel();
      } catch (e) {
        Swal.fire({ icon: "error", title: e.code || "Error", text: e.msg || "No se pudo cargar la configuración." });
      } finally {
        this.cargando = false;
      }
    },
  },
};
</script>
